import { useStatefulRef as a } from "../../use-stateful-ref/lib/index.m.es.js";
import s, { useRef as o } from "react";
function c(t, r = { isStateful: !0 }) {
  const u = a(), f = o(), e = r.isStateful ? u : f;
  return s.useImperativeHandle(t, () => e.current), e;
}
export {
  c as useForwardedRef
};
//# sourceMappingURL=index.m.es.js.map
